// src/components/utils/documentGenerator.js
import { collection, getDocs, setDoc, doc, Timestamp } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { db, storage } from '../../firebaseConfig';
import { prepareReplacementData, replacePlaceholders } from './documentHelpers';
import { generatePDFFromHTML } from './pdfGenerator';

export const generateDocumentsForUser = async (userId) => {
    console.log(`📄 Rozpoczynam generowanie dokumentów dla użytkownika: ${userId}`);
    
    try {
        // POPRAWKA: używamy "documentTemplates" z 's' na końcu!
        const templatesSnapshot = await getDocs(collection(db, 'documentTemplates'));
        
        console.log(`📄 Znaleziono szablonów: ${templatesSnapshot.size}`);
        
        if (templatesSnapshot.empty) {
            console.log('❌ Brak szablonów dokumentów w kolekcji documentTemplates');
            return false;
        }
        
        // Przygotuj dane do zastąpienia
        const replacements = await prepareReplacementData(userId);
        console.log('📄 Przygotowano dane do zastąpienia:', replacements);
        
        // Lista dokumentów do wygenerowania
        const requiredDocuments = ['RODO', 'Umowa najmu', 'Zasady współpracy'];
        let generatedCount = 0;
        
        // Dla każdego szablonu wygeneruj dokument
        const generationPromises = templatesSnapshot.docs.map(async (templateDoc) => {
            const template = templateDoc.data();
            const documentName = template.name;
            
            // Sprawdź czy to jeden z wymaganych dokumentów
            if (!requiredDocuments.includes(documentName)) {
                console.log(`⚠️ Pomijam dokument: ${documentName} (nie jest wymagany)`);
                return;
            }
            
            console.log(`📄 Generuję dokument: ${documentName}`);
            
            try {
                // Pobierz HTML content z szablonu
                const htmlContent = template.content;
                
                if (!htmlContent) {
                    console.error(`❌ Brak HTML dla szablonu: ${documentName}`);
                    return;
                }
                
                // Zastąp placeholder'y
                const processedHtml = replacePlaceholders(htmlContent, replacements);
                
                // Dodaj style dla lepszego renderowania PDF
                const fullHtml = `
                    <!DOCTYPE html>
                    <html lang="pl">
                    <head>
                        <meta charset="UTF-8">
                        <style>
                            @page { 
                                size: A4; 
                                margin: 20mm;
                            }
body { 
    font-family: Arial, sans-serif;
    font-size: 10pt;  /* Zmniejszony rozmiar */
    line-height: 1.5;  /* Dostosowana interlinia */
    color: #333;
}
                            .signature-line {
                                border-bottom: 1px dotted #000;
                                width: 300px;
                                margin-top: 40px;
                                display: inline-block;
                            }
                            .page-break {
                                page-break-after: always;
                            }
                        </style>
                    </head>
                    <body>
                        ${processedHtml}
                    </body>
                    </html>
                `;
                
                // Generuj PDF
                console.log(`📄 Generuję PDF dla: ${documentName}`);
                const pdfBlob = await generatePDFFromHTML(fullHtml);
                
                // Upload PDF do Storage
                const fileName = `documents/${userId}/${documentName.replace(/\s+/g, '_')}_${Date.now()}.pdf`;
                const storageRef = ref(storage, fileName);
                
                console.log(`📤 Uploaduję PDF: ${fileName}`);
                await uploadBytes(storageRef, pdfBlob);
                
                // Pobierz publiczny URL
                const pdfUrl = await getDownloadURL(storageRef);
                
                // Przygotuj dane dokumentu
                const now = new Date();
                const expiryDate = new Date(now);
                expiryDate.setFullYear(expiryDate.getFullYear() + 1); // Ważność 1 rok
                
                const documentData = {
                    // Metadane dokumentu
                    dataGeneracji: Timestamp.fromDate(now),
                    dataWaznosci: Timestamp.fromDate(expiryDate),
                    pdfUrl: pdfUrl,
                    
                    // Status podpisu
                    signature: '',
                    signed: false,
                    status: 'Oczekuje na podpis',
                    
                    // Informacje o dokumencie
                    documentType: documentName,
                    templateId: templateDoc.id,
                    
                    // Dodatkowe informacje
                    contractNumber: replacements.PLACEHOLDER_CONTRACT_NUMBER || '',
                    createdBy: 'system',
                    version: '1.0'
                };
                
                // Zapisz do Firestore - użyj nazwy dokumentu jako ID
                const docId = documentName.toLowerCase().replace(/\s+/g, '_');
                await setDoc(
                    doc(db, 'users', userId, 'umowy', docId),
                    documentData
                );
                
                console.log(`✅ Dokument ${documentName} zapisany pomyślnie!`);
                generatedCount++;
                
            } catch (error) {
                console.error(`❌ Błąd dla dokumentu ${documentName}:`, error);
                throw error;
            }
        });
        
        // Poczekaj aż wszystkie dokumenty się wygenerują
        await Promise.all(generationPromises);
        
        console.log(`✅ Wygenerowano ${generatedCount} z ${requiredDocuments.length} wymaganych dokumentów`);
        
        return generatedCount === requiredDocuments.length;
        
    } catch (error) {
        console.error('❌ Błąd podczas generowania dokumentów:', error);
        throw error;
    }
};